import { AxiosResponse } from 'axios';

import { ClientService } from '@/types/api';
import { InviteDTO } from '@/features/invites/dtos/invite.dto';
import { GetInvitesListResponse } from '@/api/invites/response';
import { GetInvitesListPayload, SendInvitePayload } from '@/api/invites/request';
import { InvitationRoleTypeEnum } from '@/types/invitation-role-type-enum';
import { SendInviteResponse } from '@/features/applications/types/applicationList';

export class InvitesApi {
    private prefix = 'v2/invites';

    constructor(private readonly clientService: ClientService) {
        this.clientService = clientService;
    }

    public async getProjectHistoryInvites(projectId: number, { filters, ...params }: GetInvitesListPayload): Promise<AxiosResponse<GetInvitesListResponse>> {
        return this.clientService.post(`${this.prefix}/project-history/${projectId}`, filters, {
            params,
        });
    }

    public async getUserInvites(isMe: boolean, userId: number, { filters, ...params }: GetInvitesListPayload): Promise<AxiosResponse<GetInvitesListResponse>> {
        return this.clientService.post(`${this.prefix}/${isMe ? 'my' : `user/${userId}`}`, filters, {
            params,
        });
    }

    public async checkInvite(inviteId: string): Promise<AxiosResponse<boolean>> {
        return this.clientService.get(`${this.prefix}/${inviteId}/check`);
    }

    public async sendInvite(projectId: number | number[], role: InvitationRoleTypeEnum, data: SendInvitePayload): Promise<AxiosResponse<SendInviteResponse>> {
        if (!role) {
            return;
        }

        const suffix = {
            [InvitationRoleTypeEnum.LEADER]: 'leader',
            [InvitationRoleTypeEnum.TEAM_MEMBER]: 'team-member',
            [InvitationRoleTypeEnum.OTHER]: 'other',
            [InvitationRoleTypeEnum.TRACKER]: 'tracker',
            [InvitationRoleTypeEnum.PARTNER]: 'partner',
            [InvitationRoleTypeEnum.EXPERT]: 'expert',
        }[role];
        if (!suffix) {
            throw new Error('Неизвестная роль');
        }
        const payload = Array.isArray(projectId) ? { ...data, projectIds: projectId } : { ...data, projectId };
        return this.clientService.post<SendInviteResponse>(`${this.prefix}/${suffix}`, payload);
    }

    public async respondToInvite(inviteId: string, data: {
        status: string;
        message?: string;
    }): Promise<boolean> {
        const response = await this.clientService.post<boolean>(`${this.prefix}/${inviteId}/respond`, data);
        return response.data;
    }

    public async revokeInvite(inviteId: string): Promise<AxiosResponse<InviteDTO>> {
        return this.clientService.post(`${this.prefix}/${inviteId}/revoke`);
    }
}
